var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.assistant.workLocation == _vm.tileName)?_c('i',{staticClass:"fa fa-user fa-2x floating-ass",class:[_vm.color],attrs:{"aria-hidden":"true"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }